export default "__VITE_ASSET__0c8a5e4e__"